module.exports = __webpack_public_path__ + "img/2.dda06573.png";